import { createApp, h } from 'vue'
import App from './App.vue'
import singleSpaVue from 'single-spa-vue'
import router from './router'
import createVuetifyPlugin from './plugins/vuetify.js'
import i18n from './locales/i18n.js'
import store from "./store";
import pkg from '../package.json'

let singleSpaProps = {}
const mfName = singleSpaProps.name || pkg.name || "unknown-microfrontend";
const keyName = mfName + "-config";

// i18n instance configured with dynamic messages and Vuetify merge

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      return h(App, {
        singleSpaProps: singleSpaProps,
        mfConfig: singleSpaProps[keyName] || singleSpaProps,
        palette: singleSpaProps.palette,
        realm: singleSpaProps.realm,
      })
    }
  },
  handleInstance: (app, props) => {
    singleSpaProps = props
    // Configure Vuetify with the palette received from props
    const vuetify = createVuetifyPlugin(props.palette || {}, i18n)
    app.use(vuetify)
    app.use(router)
    app.use(i18n);
    app.use(store);
    //To provide file configs to the descendants of a component with Provide/Inject functions
    app.provide("config", singleSpaProps[keyName]);
    app.provide("tenant", props.realm);
  }
})

console.log("Mounted " + mfName + " v", pkg.version);

export const bootstrap = vueLifecycles.bootstrap
export const mount = vueLifecycles.mount
export const unmount = vueLifecycles.unmount
